(function(){
  "use strict";
    angular.module('irricrops')

    .controller("vinedoSPCtrl", ["$scope", 'MultiChart', 'Config','$http','urls','menu','global','$stateParams','temporadaFac', '$timeout','vinedo',
      function($scope  , MultiChart , Config  , $http , urls , menu , global , $stateParams, temporadaFac, $timeout, vinedo){

        var vm               = this;
        var vinedoId         = $stateParams.id;
        vm.sectoresData      = [];
        vm.headerSemanas     = [];
        vm.loadingGeneral    = true;
        vm.data              = [];
        vm.temporadas        = [];
        vm.temporadaSelected = null;
        vm.headerVars        = [
          {name : "Riego", var:"dia_horas"},
          {name : "Perfect", var:"frecuencia_horas"},
        ];




        temporadaFac.getTemporadas().then(function(res) {
          vm.temporadas        = res.data.data;
          vm.temporadaSelected = temporadaFac.getActiva();
          vm.init();
        });

        vm.init = function(){
          vm.loadingGeneral = true;
          vm.headerSemanas  = [];
          vm.data           = [];

          var prom = $http.get(urls.BASE + "/analisis/indice-riego", {
            params : {
              vinedo_id: vinedoId,
              periodo: vm.temporadaSelected.periodo
            }
          });
          prom.then(function(res){

            var filtroSemana = function(semana){ return moment(semana.fin).isBefore(new moment()) };


            //https://github.com/lodash/lodash/issues/1148
            function isNumeric(x) {
              return !(isNaN(x)) && (typeof x !== "object") &&
                (x != Number.POSITIVE_INFINITY) && (x != Number.NEGATIVE_INFINITY);
            }


            vm.data = res.data.data;
            var sectoresData = _.flatMap(vm.data, function(cuartel){

              cuartel.promedios = {
                dia_horas        : _(cuartel.semanas).filter('meta')
                .filter(filtroSemana)
                .map(function(s){
                  return (s.dia_horas / s.meta) * 100;
                }).mean(),

                frecuencia_horas : _(cuartel.semanas).filter('meta')
                .filter(filtroSemana)
                .map(function(s){
                  return (s.frecuencia_horas / s.meta) * 100;
                }).mean(),
              }



              return _.flatMap(cuartel.equipos, function(equipo){
                if(vm.headerSemanas.length == 0){
                  vm.headerSemanas = _.mapValues(equipo.sectores[0].semanas, function(sem){return sem})
                }


                equipo.show = false;

                equipo.promedios = {
                  dia_horas        : _(equipo.semanas).filter('meta')
                  .filter(filtroSemana)
                  .map(function(s){
                    return (s.dia_horas / s.meta) * 100;
                  }).mean(),
                  frecuencia_horas : _(equipo.semanas).filter('meta')
                  .filter(filtroSemana)
                  .map(function(s){
                    return (s.frecuencia_horas / s.meta) * 100;
                  }).mean(),
                }

                _.forEach(equipo.sectores, function(sector){
                  sector.promedios = {
                    dia_horas        : _(sector.semanas).filter('meta')
                    .filter(filtroSemana)
                    .map(function(s){
                      return (s.dia_horas / s.meta) * 100;
                    }).mean(),
                    frecuencia_horas : _(sector.semanas).filter('meta')
                    .filter(filtroSemana)
                    .map(function(s){
                      return (s.frecuencia_horas / s.meta) * 100;
                    }).mean(),
                  }
                });

                return equipo.sectores;
              });
            });

            //vm.data = _.groupBy(vm.data, 'encargado');
            /*
          vm.data =_.reduce(vm.data, function(r, a) {
            console.log("a", a);
            console.log('r', r);

            r[a.encargado] = r[a.encargado] || {
              encargado:a.encargado,
              semanas: "TODO rellenar",
              promedios : {//REVISAR
                dia_horas        : _(vm.data).filter(function(s){return s.promedios.dia_horas != undefined;}).meanBy('dia_horas'),
                frecuencia_horas : _(vm.data).filter(function(s){return s.promedios.frecuencia_horas != undefined;}).meanBy('frecuencia_horas'),
              },
              cuarteles: []
            };

            r[a.encargado].cuarteles.push(a);

            return r;
          }, {});
          */

            vm.loadingGeneral = false;
          }); // prom then 
        }


        vm.toXls = function(){

          var fileName   = vinedo.data.nombre;
          var workbook   = XLSX.utils.book_new();
          //var headers    = props.headers;


          var headerSemanasXls = [ "", "", "", ""];
          var headerVariablesXls = ["Caseta", "Encargado", "Equipo", "Sector Riego"];
          _.forEach(vm.headerSemanas, headerSemana => {
            _.forEach(vm.headerVars, (headerVar, indexVar) => {
              if(indexVar == 0){
                headerSemanasXls.push(headerSemana.sem);
              }else{
                headerSemanasXls.push("");
              }
              headerVariablesXls.push(headerVar.name);
            });
          });

          //var rowsTop    = headerSemana.rowsTop || [];

          var dataAoA = [];
          _.forEach(vm.data, caseta => {

            let dataItem = [caseta.nombre, caseta.encargado, "", ""];
            _.forEach(vm.headerSemanas, headerSemana => {
              let semana = _.find( caseta.semanas, {sem: headerSemana.sem});
              _.forEach(vm.headerVars, h => {
                var r = _.get(semana, h.var);
                if(_.isNumber(r) && semana.meta > 0){
                  dataItem.push( _.round( (r / semana.meta ) *100, 1) );
                }else{
                  dataItem.push("");
                }
              });
            });
            dataAoA.push(dataItem);



              _.forEach( caseta.equipos, equipo => {
                let dataItem = ["", "", equipo.nombre, ""];
                _.forEach(vm.headerSemanas, headerSemana => {
                  let semana = _.find(equipo.semanas, {sem: headerSemana.sem});
                  _.forEach(vm.headerVars, h => {
                    var r = _.get(semana, h.var);
                    if(_.isNumber(r) && semana.meta > 0){
                      dataItem.push( _.round( (r / semana.meta ) *100, 1) );
                    }else{
                      dataItem.push("");
                    }
                  });
                });
                dataAoA.push(dataItem);




              _.forEach(equipo.sectores, sector => {
                let dataItem = ["", "", "",sector.nombre];
                _.forEach(vm.headerSemanas, headerSemana => {
                  let semana = _.find(sector.semanas, {sem: headerSemana.sem});
                  _.forEach(vm.headerVars, h => {
                    var r = _.get(semana, h.var);
                    if(_.isNumber(r)){
                      dataItem.push( r );
                    }else{
                      dataItem.push("");
                    }
                  });
                });
                dataAoA.push(dataItem);
              });




              });

          });


          dataAoA.unshift(headerVariablesXls);
          dataAoA.unshift(headerSemanasXls);
          //dataAoA = rowsTop.concat(dataAoA);

          var sheet = XLSX.utils.aoa_to_sheet(dataAoA);

          var colsConfig = _.flatMap(vm.headerSemanas, h => {
            return _.map(vm.headerVars, headerVar => {
              return {wpx:50};
            });
          });
          colsConfig = [{wpx: 100},{wpx: 100},{wpx: 100},{wpx: 100}];
          sheet["!cols"] = colsConfig;

          XLSX.utils.book_append_sheet(workbook,sheet, vinedo.data.nombre );

          XLSX.writeFile(workbook, `${fileName}.xlsx`);
        }


      }]);
})();
